import { formatDateTime } from "@/common/utils/formatters";
import { RecipientMessagesData } from "../types/recipientMessages.type";
import { recipientMessagesStatus } from "../constants/recipientMessagesStatus";
import { providerKlass } from "../constants/providerKlass";

export class RecipientMessagesManagementTransformer {
  static tableTransformer() {
    return (recipientMessages: RecipientMessagesData[]) => {
      return recipientMessages.map((recipientMessage) => {
        return {
          ...recipientMessage,
          status: recipientMessage.status ? recipientMessagesStatus[recipientMessage.status] : '--',
          method: recipientMessage.provider_klass ? providerKlass[recipientMessage.provider_klass] : '--',
          subject: recipientMessage.message.notification_display_name || '--',
          sent_at: recipientMessage.sent_at ? formatDateTime(new Date(recipientMessage.sent_at)) : '--'
        };
      });
    };
  }
}
